export const REQUIRED_FIELDS = [
    {
        name: "title_en",
        label: "Title English",
        type: "text",
    },
    { name: "story", label: "Story", type: "multiline", multiline: true, minRows: 3 },
    { name: "location_country", label: "Country", type: "text" },
    { name: "rdd", label: "RDD", type: "id-list" },
];

export const OPTIONAL_FIELDS = [
    { name: "title", label: "Title (local language)", type: "text" },
    { name: "aim", label: "Aim", type: "multiline", multiline: true, minRows: 3 },
    
    { name: "lead_org_name", label: "Lead Organisation", type: "text" },
    { name: "website", label: "Website", type: "text" },
    
    { name: "impacts", label: "Impacts", type: "multiline", multiline: true, minRows: 3 },
    { name: "beneficiaries", label: "Beneficiaries", type: "text" },
    { name: "beneficiaries_details", label: "Beneficiaries details", type: "text" },
    { name: "location_region", label: "Location region", type: "text" },
    { name: "location_town", label: "Location town", type: "text" },
    { name: "lead_org_country", label: "Lead org country", type: "text" },
    { name: "lead_org_region", label: "Lead org region", type: "text" },
    { name: "lead_org_town", label: "Lead org town", type: "text" },
    { name: "lead_org_other", label: "Lead org other", type: "text" },
    { name: "other_orgs", label: "Other organisations", type: "text" },
    { name: "notes", label: "Notes", type: "multiline", multiline: true, minRows: 3 },
    { name: "source", label: "Source", type: "text" },
    { name: "lead_org_type", label: "Lead org type", type: "integer" },
    { name: "changes", label: "Changes", type: "integer" },
    { name: "continuation", label: "Continuation", type: "integer" },
    
    { name: "challenges", label: "Challenges", type: "id-list" },
    { name: "priorities", label: "Priorities", type: "id-list" },
    { name: "barriers", label: "Barriers", type: "id-list" },
    { name: "biodiversity", label: "Biodiversity", type: "id-list" },
    { name: "capitals", label: "Capitals", type: "id-list" },
    { name: "innovation_social", label: "Innovation social", type: "id-list" },
    { name: "climatechange_mitigation", label: "Climate change mitigation", type: "id-list" },
    { name: "categories_agrifood", label: "Category agrifood", type: "id-list" },
    { name: "categories_energy", label: "Category energy", type: "id-list" },
    { name: "categories_mobility", label: "Category mobility", type: "id-list" },
    { name: "categories_tourism", label: "Category tourism", type: "id-list" },
    { name: "climatechange_adaptation", label: "Climate change adaptation", type: "id-list" },
    { name: "development_approach", label: "Development approach", type: "id-list" },
    { name: "enbling_conditions", label: "Enabling conditions", type: "id-list" },
    { name: "founding", label: "Founding", type: "id-list" },
    { name: "geographical_featues", label: "Geographical features", type: "id-list" },
    { name: "innovation_culture", label: "Innovation culture", type: "id-list" },
    { name: "innovation_digital_chars", label: "Innovation digital chars", type: "id-list" },
    { name: "innovation_financial", label: "Innovation financial", type: "id-list" },
    { name: "innovation_technical", label: "Innovation technical", type: "id-list" },
    { name: "local_services", label: "Local services", type: "id-list" },
    { name: "replicability", label: "Replicability", type: "id-list" },
    { name: "social_justice", label: "Social justice", type: "id-list" },
    { name: "stakeholders_partecipation", label: "Stakeholders participation", type: "id-list" },
    { name: "territorial_features", label: "Territorial features", type: "id-list" },
    { name: "territorial_implementation_scale", label: "Territorial implementation scale", type: "id-list" },
    { name: "api", label: "API available", type: "boolean" },
    { name: "geospatial", label: "Geospatial data", type: "boolean" },
    { name: "lead_women", label: "Led by women", type: "boolean" },
    { name: "innovation_digital", label: "Digital innovation", type: "boolean" },
];


export const hasFieldValue = (field, value) => {
    switch (field.type) {
        case "boolean":
            return Boolean(value);

        case "integer":
            return value !== null && value !== undefined && value !== "";

        case "id-list":
            return Array.isArray(value) && value.length > 0;

        default:
            return (
                value !== undefined &&
                value !== null &&
                String(value).trim() !== ""
            );
    }
};

export const getEmptyFieldValue = (field) => {
    switch (field.type) {
        case "boolean":
            return false;

        case "integer":
            return null;

        case "id-list":
            return [];

        default:
            return "";
    }
};